// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"92dc4c10","572":"ea24a1e5","590":"92dc4c10","693":"92dc4c10","795":"92dc4c10"}[chunkId] + ".css";
};